/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaboratoremailplaceholder3Inputs */

const en_settings_collaborators_invitecollaboratoremailplaceholder3 = /** @type {(inputs: Settings_Collaborators_Invitecollaboratoremailplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the email address`)
};

/**
* | output |
* | --- |
* | "Enter the email address" |
*
* @param {Settings_Collaborators_Invitecollaboratoremailplaceholder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaboratoremailplaceholder3 = /** @type {((inputs?: Settings_Collaborators_Invitecollaboratoremailplaceholder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaboratoremailplaceholder3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaboratoremailplaceholder3(inputs)
});
export { settings_collaborators_invitecollaboratoremailplaceholder3 as "settings_collaborators_inviteCollaboratorEmailPlaceholder" }